// extracted by mini-css-extract-plugin
export default {"hidden":"a8tcUE"};